import {
  suffixSafeId,
  TLDefaultColorStyle,
  TLDefaultColorTheme,
  TLDefaultFillStyle,
  useEditor,
  useSharedSafeId,
  useSvgExportContext,
  useValue,
} from "tldraw"
import React, { useCallback } from "react"

function getPatternLodForZoomLevel(zoom: number) {
  return Math.ceil(Math.log2(Math.max(1, zoom)))
}
export function useGetHashPatternZoomName() {
  const id = useSharedSafeId("hash_pattern")
  return useCallback(
    (zoom: number, theme: TLDefaultColorTheme["id"]) => {
      const lod = getPatternLodForZoomLevel(zoom)
      return suffixSafeId(id, `${theme}_${lod}`)
    },
    [id],
  )
}

interface ShapeFillProps {
  d: string
  fill: TLDefaultFillStyle
  color: string
  theme: TLDefaultColorTheme
  scale: number
  opacity: number
}

export const ShapeFill = React.memo(function ShapeFill({
  theme,
  d,
  color,
  fill,
  scale,
  opacity,
}: ShapeFillProps) {
  switch (fill) {
    case "none": {
      return null
    }
    case "solid": {
      return <path fill={color} d={d} opacity={opacity} />
    }
    case "semi": {
      return <path fill={theme.solid} d={d} opacity={opacity} />
    }
    case "fill": {
      return <path fill={color} d={d} opacity={opacity} />
    }
    case "pattern": {
      return (
        <PatternFill
          theme={theme}
          color={color}
          fill={fill}
          d={d}
          scale={scale}
        />
      )
    }
  }
})

export function PatternFill({ d, color, theme }: ShapeFillProps) {
  const editor = useEditor()
  const svgExport = useSvgExportContext()
  const zoomLevel = useValue("zoomLevel", () => editor.getZoomLevel(), [editor])
  const getHashPatternZoomName = useGetHashPatternZoomName()

  const teenyTiny = editor.getZoomLevel() <= 0.18

  return (
    <>
      <path fill={color} d={d} />
      <path
        fill={
          svgExport
            ? `url(#${getHashPatternZoomName(1, theme.id)})`
            : teenyTiny
              ? color
              : `url(#${getHashPatternZoomName(zoomLevel, theme.id)})`
        }
        d={d}
      />
    </>
  )
}
